"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.todos.completed': 'Abgeschlossen',
    'tutorial.todos.pending': 'Ausstehend',
    'tutorial.todos.markCompleted': 'Als erledigt markieren',
    'tutorial.todos.markPending': 'Als ausstehend markieren',
    'tutorial.todos.statusDone': 'erledigt',
    'tutorial.todos.statusUndone': 'nicht erledigt',
    'tutorial.todos.changeComment.1': 'Du hast den Status der Aufgabe „{name}“ geändert auf: {status}.',
    'tutorial.todos.changeComment.2': 'Aufgabe „{name}“ – {status}. Notiert.',
    'tutorial.todos.changeComment.3': 'Ich habe die Änderung vermerkt: Die Aufgabe „{name}“ ist jetzt {status}.',
    'tutorial.todos.changeComment.4': 'Gespeichert! Die Aufgabe „{name}“ ist als {status} markiert.',
    'tutorial.audio.stop': 'Stopp',
    'tutorial.audio.pause': 'Pause',
    'tutorial.audio.play': 'Abspielen',
    'tutorial.audio.volume': 'Lautstärke',
    'tutorial.audio.writingSpeed': 'Schreibgeschwindigkeit',
    'tutorial.audio.writingSpeed.normal': 'Normal',
    'tutorial.audio.writingSpeed.fast': 'Schnell',
    'tutorial.audio.writingSpeed.veryFast': 'Sehr schnell',
};
